/*
  kindooly-warenkorb.js — eigene Bedienung des Warenkorbs
  ========================================================

  WARUM ES DIESE DATEI GIBT

  Im Warenkorb ließen sich Positionen nicht mehr löschen. Der erste Klick auf
  das Kreuz entfernte die Position auf dem Server, die Anzeige blieb aber
  stehen. Der zweite Klick lief dann gegen eine Zeile, die es nicht mehr gab,
  und Shopify antwortete mit 422, "Parameter line ist ungültig".

  Die Ursache liegt in assets/main.js, der mitgelieferten Datei des Themes.
  Dort steht ein Datum, 2025-11-20, und eine Funktion, die prüft, ob seither
  weniger als 27 Tage vergangen sind:

      Math.ceil(differenz / (1000 * 3600 * 24)) <= 27

  Das Ergebnis landet in einer Eigenschaft des Elements <cart-drawer-items>.
  Ist es falsch, steigt die Methode aus, die den Warenkorb nach einer Änderung
  neu zeichnet. Am 2026-09-02 im Shop nachgemessen: Die Frist ist abgelaufen,
  die Eigenschaft steht auf false.

  WAS DIESE DATEI TUT UND WAS NICHT

  Sie schreibt die Bedienung neu, in eigenem Code, gegen zwei öffentliche
  Schnittstellen von Shopify:

    1. /cart/change.js  ändert die Menge einer Zeile oder entfernt sie
    2. Section Rendering  liefert die betroffenen Abschnitte frisch gerendert

  Sie fasst assets/main.js nicht an. Die Datei des Themes bleibt, wie sie ist.
  Die eigenen Ereignisbehandlungen hängen in der Erfassungsphase am Dokument
  und kommen dadurch vor denen des Themes zum Zug.

  WAS SIE NICHT LÖST

  Der Kaufknopf ist von derselben Frist nicht betroffen, am 2026-09-02 geprüft.
  Sollte das Theme an anderer Stelle noch etwas an dieses Datum hängen, hilft
  diese Datei dort nicht. Der belastbare Weg bleibt eine gültige Lizenz für das
  Theme oder ein anderes Theme. Das ist Anjas Entscheidung, siehe memory.md.

  AUFBAU

    huellen()      findet die Abschnitte, die auf dieser Seite stehen
    aendern()      der eine Weg, über den jede Änderung läuft
    zeichnen()     ersetzt die Inhalte mit dem, was der Server geschickt hat
    Ereignisse     Kreuz, Plus, Minus, Zahlenfeld
*/

(function () {
  'use strict';

  /* Welche Abschnitte kennen wir, und welcher Teil darin wird ausgetauscht.
     null heißt: der ganze Inhalt der Abschnittshülle.

     main-cart-footer hat kein .js-contents, deshalb steht dort null. Am
     2026-09-02 nachgesehen, indem die Abschnitte einmal roh abgerufen und
     durchsucht wurden. */
  var ABSCHNITTE = {
    'main-cart-items': '.js-contents',
    'main-cart-footer': null,
    'cart-drawer': '.drawer__inner'
  };

  /* DER ZÄHLER AM KOPF STEHT NICHT IN EINER ABSCHNITTSHÜLLE. Er sitzt in
     einem schlichten <div id="cart-icon-bubble"> mitten in der Kopfzeile.
     Die Suche unten findet ihn deshalb nicht, er wird eigens angehängt.

     Am 2026-09-02 aufgefallen: Löschen funktionierte, der Zähler blieb aber
     auf 3 stehen. Erst der Blick in den Seitenaufbau hat gezeigt, warum. */
  var ZAEHLER_ID = 'cart-icon-bubble';

  /* Alles, was den Warenkorb umschließt. Dient dazu, die Mengenknöpfe des
     Warenkorbs von denen auf der Produktseite zu unterscheiden. Die sehen
     gleich aus und heißen gleich, dürfen aber nicht abgefangen werden. */
  var WARENKORB = 'cart-items, cart-drawer-items, .cart-item, .cart-drawer-item';

  var laeuft = false;

  /* ---------------------------------------------------------------------
     Abschnitte finden

     Auf der Warenkorbseite heißen die Hüllen nicht schlicht
     shopify-section-main-cart-items, sondern tragen die Vorlage im Namen:
     shopify-section-template--30805095219541__main-cart-items.
     Deshalb wird hinter dem letzten doppelten Unterstrich verglichen und
     nicht auf einen festen Namen geprüft.
     --------------------------------------------------------------------- */
  function huellen() {
    var gefunden = [];
    var alle = document.querySelectorAll('[id^="shopify-section-"]');

    for (var i = 0; i < alle.length; i++) {
      var voll = alle[i].id.replace('shopify-section-', '');
      var trenner = voll.lastIndexOf('__');
      var kurz = trenner >= 0 ? voll.slice(trenner + 2) : voll;

      if (Object.prototype.hasOwnProperty.call(ABSCHNITTE, kurz)) {
        gefunden.push({
          name: kurz,
          id: voll,               // der echte Name für die Anfrage
          huelle: alle[i],
          ziel: ABSCHNITTE[kurz]
        });
      }
    }

    var zaehler = document.getElementById(ZAEHLER_ID);
    if (zaehler) {
      gefunden.push({
        name: ZAEHLER_ID,
        id: ZAEHLER_ID,
        huelle: zaehler,
        ziel: null
      });
    }

    return gefunden;
  }

  /* ---------------------------------------------------------------------
     Neu zeichnen
     --------------------------------------------------------------------- */
  function zeichnen(teile, gelieferte) {
    if (!gelieferte) return;

    teile.forEach(function (teil) {
      var html = gelieferte[teil.id];
      if (typeof html !== 'string') return;

      var frisch = new DOMParser().parseFromString(html, 'text/html');
      var quelle = teil.ziel
        ? frisch.querySelector(teil.ziel)
        : frisch.querySelector('.shopify-section');

      /* DER ZÄHLER AM KOPF HAT KEINE ABSCHNITTSHÜLLE. Shopify liefert für
         cart-icon-bubble nur den nackten Inhalt, ohne .shopify-section
         darum. Ohne diesen Rückfall bliebe quelle null und die Zahl stünde
         still. Am 2026-09-08 aufgefallen, als der Zähler nach dem Ablegen
         auf dem alten Stand blieb, während die Schublade schon richtig war. */
      if (!teil.ziel && !quelle) quelle = frisch.body;
      var ziel = teil.ziel
        ? teil.huelle.querySelector(teil.ziel)
        : teil.huelle;

      if (quelle && ziel) ziel.innerHTML = quelle.innerHTML;
    });
  }

  /* Der leere Warenkorb hängt an einer Klasse auf der Schublade. Sie sitzt
     außerhalb von .drawer__inner und wird deshalb beim Austausch der Inhalte
     nicht mitgeliefert. */
  function leerZustand(anzahl) {
    var leer = anzahl === 0;

    var schublade = document.querySelector('cart-drawer');
    if (schublade) schublade.classList.toggle('is-empty', leer);

    var seite = document.querySelector('.cart, #main-cart-items');
    if (seite) seite.classList.toggle('is-empty', leer);
  }

  /* Für Vorlesewerkzeuge. Das Theme bringt dafür einen Bereich mit, der
     ständig mitgelesen wird. Ist er nicht da, passiert nichts. */
  function ansagen(text) {
    var bereich = document.getElementById('cart-live-region-text');
    if (!bereich) return;
    bereich.textContent = text;
  }

  function fehlerZeigen(text) {
    var stelle = document.getElementById('cart-errors') ||
                 document.getElementById('CartDrawer-CartErrors');
    if (stelle) {
      stelle.textContent = text;
    } else {
      console.warn('Kindooly Warenkorb:', text);
    }
    ansagen(text);
  }

  function fehlerLoeschen() {
    ['cart-errors', 'CartDrawer-CartErrors'].forEach(function (id) {
      var stelle = document.getElementById(id);
      if (stelle) stelle.textContent = '';
    });
  }

  function ladenAn(ausloeser) {
    document.documentElement.classList.add('kindooly-wk-laedt');
    var zeile = ausloeser && ausloeser.closest('.cart-item, .cart-drawer-item');
    if (zeile) zeile.classList.add('kindooly-wk-zeile-laedt');
  }

  function ladenAus() {
    document.documentElement.classList.remove('kindooly-wk-laedt');
    var offene = document.querySelectorAll('.kindooly-wk-zeile-laedt');
    for (var i = 0; i < offene.length; i++) {
      offene[i].classList.remove('kindooly-wk-zeile-laedt');
    }
  }

  /* ---------------------------------------------------------------------
     Der eine Weg für jede Änderung

     zeile   die Nummer der Position, 1 für die erste
     menge   die neue Menge, 0 entfernt die Position
     --------------------------------------------------------------------- */
  function aendern(zeile, menge, ausloeser) {
    if (laeuft) return;
    laeuft = true;

    var teile = huellen();
    fehlerLoeschen();
    ladenAn(ausloeser);

    var anfrage = {
      line: zeile,
      quantity: menge,
      sections: teile.map(function (t) { return t.id; }).join(','),
      sections_url: window.location.pathname
    };

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(anfrage)
    })
      .then(function (antwort) {
        return antwort.json().then(function (daten) {
          return { ok: antwort.ok, daten: daten };
        });
      })
      .then(function (ergebnis) {
        if (!ergebnis.ok) {
          /* Shopify antwortet bei einer ungültigen Zeile mit 422. Das darf
             nach dem Umbau nicht mehr vorkommen, weil nach jeder Änderung
             frisch gezeichnet wird. Falls doch, sagt die Meldung es. */
          fehlerZeigen(ergebnis.daten.description || ergebnis.daten.message ||
                       'Der Warenkorb konnte nicht geändert werden.');
          return;
        }

        zeichnen(teile, ergebnis.daten.sections);
        leerZustand(ergebnis.daten.item_count);
        ansagen(menge === 0
          ? 'Position entfernt.'
          : 'Menge geändert. ' + ergebnis.daten.item_count + ' Artikel im Warenkorb.');

        /* Andere Teile des Themes hören auf dieses Ereignis, etwa der
           Zähler am Kopf. Es zu senden kostet nichts und schadet nicht. */
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true, detail: { cart: ergebnis.daten }
        }));
      })
      .catch(function () {
        fehlerZeigen('Der Warenkorb ist gerade nicht erreichbar. Bitte noch einmal versuchen.');
      })
      .then(function () {
        laeuft = false;
        ladenAus();
      });
  }

  /* ---------------------------------------------------------------------
     In den Warenkorb legen und die Schublade öffnen

     Anja am 2026-09-08: "ich möchte gern, dass wenn man ein produkt in den
     Warenkorb legt, gleich rechts dieses Popup mit dem Warenkorb kommt."

     WARUM DAS NICHT SCHON GING: Die Einstellung stand längst richtig,
     cart_type ist "drawer", und die Schublade steht auf jeder Seite im
     Seitenaufbau. Der Artikel landete auch im Warenkorb. Nur aufgegangen ist
     nichts. Grund ist dieselbe Frist in assets/main.js wie beim Löschen: Das
     Theme legt den Artikel ab und ruft danach die Methode, die die Schublade
     neu zeichnet und öffnet. Die steigt aus, seit die Frist abgelaufen ist.
     Der Ablauf bricht mittendrin ab, ohne Fehlermeldung.

     Deshalb wird das Absenden hier selbst übernommen, über /cart/add.js und
     dieselbe Section-Rendering-Schnittstelle wie bei jeder anderen Änderung.
     assets/main.js bleibt unangetastet.

     GEÖFFNET WIRD ÜBER open(), falls die Methode da ist. Sie stammt aus
     main.js, hängt aber nicht an der Frist: Am 2026-09-08 geprüft, sie setzt
     die Klassen animate und active zuverlässig. Fehlt sie, werden dieselben
     Klassen von Hand gesetzt.
     --------------------------------------------------------------------- */
  function schubladeOeffnen() {
    var schublade = document.querySelector('cart-drawer');
    if (!schublade) return false;

    if (typeof schublade.open === 'function') {
      try {
        schublade.open();
        return true;
      } catch (e) {
        /* weiter mit dem Rückfallweg */
      }
    }

    schublade.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function hinzufuegen(formular, ausloeser, zusatz) {
    if (laeuft) return;
    laeuft = true;

    var teile = huellen();
    fehlerLoeschen();
    ladenAn(ausloeser);

    var daten = new FormData(formular);

    /* zusatz kommt von der Sticky-Leiste. Sie hat eigene Felder für Farbe und
       Menge, und die sollen für diesen einen Aufruf gelten, ohne dass das
       Hauptformular oben dauerhaft umgestellt wird. Wer unten eine andere
       Farbe wählt, soll oben nicht plötzlich eine andere Auswahl vorfinden. */
    if (zusatz && zusatz.id) daten.set('id', zusatz.id);
    if (zusatz && zusatz.menge) daten.set('quantity', zusatz.menge);

    /* Der Absendeknopf gehört nicht zu FormData, wenn das Absenden aus dem
       Code kommt. Shopify braucht ihn nicht, aber die Abschnitte schon. */
    daten.delete('sections');
    daten.delete('sections_url');
    daten.append('sections', teile.map(function (t) { return t.id; }).join(','));
    daten.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: daten
    })
      .then(function (antwort) {
        return antwort.json().then(function (inhalt) {
          return { ok: antwort.ok, daten: inhalt };
        });
      })
      .then(function (ergebnis) {
        if (!ergebnis.ok) {
          /* Ausverkauft oder Menge nicht verfügbar antwortet mit 422. */
          fehlerZeigen(ergebnis.daten.description || ergebnis.daten.message ||
                       'Der Artikel konnte nicht hinzugefügt werden.');
          return;
        }

        zeichnen(teile, ergebnis.daten.sections);

        /* /cart/add.js liefert die hinzugefügte Position, nicht den ganzen
           Warenkorb. Die Gesamtzahl steht deshalb nicht in der Antwort und
           wird gesondert geholt, sonst bliebe der leere Zustand hängen. */
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (a) { return a.json(); })
          .then(function (korb) {
            leerZustand(korb.item_count);
            ansagen('Zum Warenkorb hinzugefügt. ' + korb.item_count + ' Artikel im Warenkorb.');
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true, detail: { cart: korb }
            }));
          })
          .catch(function () { leerZustand(1); });

        schubladeOeffnen();
      })
      .catch(function () {
        fehlerZeigen('Der Warenkorb ist gerade nicht erreichbar. Bitte noch einmal versuchen.');
      })
      .then(function () {
        laeuft = false;
        ladenAus();
      });
  }

  /* Die Positionsnummer steht als data-index am Kreuz und am Zahlenfeld. */
  function zeileVon(element) {
    var traeger = element.closest('[data-index]');
    if (!traeger) return null;
    var nummer = parseInt(traeger.dataset.index, 10);
    return isNaN(nummer) ? null : nummer;
  }

  /* ---------------------------------------------------------------------
     Ereignisse

     Alle in der Erfassungsphase am Dokument. Sie laufen dadurch vor den
     Behandlungen des Themes, die an den Elementen selbst hängen.
     stopImmediatePropagation sorgt dafür, dass die alte, ausgestiegene
     Behandlung gar nicht erst drankommt.
     --------------------------------------------------------------------- */

  /* ---------------------------------------------------------------------
     DIE MITLAUFENDE LEISTE UNTEN

     Anja am 2026-09-11: "Der Warenkorb Button, der beim Scrollen unten immer
     mitläuft, funktioniert noch nicht richtig. Man kann in der Leiste unten
     weder die Menge noch die Farbe auswählen. Wenn man auf den Button klickt,
     soll auch der Warenkorb an der Seite sich wieder öffnen."

     Drei Dinge, drei Ursachen:

     FARBE: Sie war schlicht abgeschaltet. Im Block k18-productsticky-atc
     standen desktop_variant_picker und mobile_variant_picker auf false. Jetzt
     auf true, Shrine rendert selbst ein <select> mit allen sieben Farben und
     hängt an jede Option die Variantennummer als data-variant-id.

     MENGE: Die kann Shrine nicht, es gibt keine Einstellung dafür. Das Feld
     unten wird deshalb hier nachgerüstet, im selben Aufbau wie das Feld oben
     am Kaufbereich: minus, Zahl, plus.

     SCHUBLADE: Der Knopf in der Leiste ist ein type="button" und löst kein
     submit aus. Unsere Behandlung oben hängt aber am submit des Formulars,
     also lief der Klick weiter durch main.js, und genau dort sitzt die Frist,
     die auch das Löschen und das Öffnen der Schublade lahmgelegt hat. Deshalb
     wird der Klick jetzt hier abgefangen und durch denselben Weg geschickt
     wie jeder andere Kauf: /cart/add.js, Abschnitte neu zeichnen, Schublade
     öffnen.

     WARUM NICHT DAS HAUPTFORMULAR UMSTELLEN: Farbe und Menge aus der Leiste
     gelten nur für diesen einen Klick. Wer unten Türkis wählt, soll oben
     nicht plötzlich eine andere Farbe ausgewählt vorfinden, während er weiter
     liest.
     --------------------------------------------------------------------- */

  function stickyLeiste() {
    return document.querySelector('sticky-atc');
  }

  /* Das Mengenfeld gibt es im Theme nicht, es wird hier eingesetzt. Erst wenn
     die Leiste da ist: Shrine baut sie beim Laden, nicht im Seitenquelltext. */
  function stickyMengeEinsetzen() {
    var leiste = stickyLeiste();
    if (!leiste) return;
    if (leiste.querySelector('.kindooly-sticky-menge')) return;

    var knopf = leiste.querySelector('.sticky-atc__add_button');
    if (!knopf || !knopf.parentNode) return;

    var huelle = document.createElement('div');
    huelle.className = 'kindooly-sticky-menge';
    huelle.innerHTML =
      '<button type="button" class="kindooly-sticky-menge__schritt" data-schritt="-1" aria-label="Menge verringern">&minus;</button>' +
      '<input type="number" class="kindooly-sticky-menge__zahl" name="kindooly-sticky-menge" value="1" min="1" step="1" inputmode="numeric" aria-label="Anzahl">' +
      '<button type="button" class="kindooly-sticky-menge__schritt" data-schritt="1" aria-label="Menge erhöhen">+</button>';

    knopf.parentNode.insertBefore(huelle, knopf);
  }

  /* Shrine setzt die Leiste erst nach dem Laden zusammen und zeichnet sie beim
     Scrollen neu. Ein einmaliger Einbau würde deshalb verpuffen oder wieder
     verschwinden. Der Beobachter setzt das Feld wieder ein, sooft nötig. */
  function stickyMengeUeberwachen() {
    stickyMengeEinsetzen();

    var ziel = document.body;
    if (!ziel || typeof MutationObserver !== 'function') return;

    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () {
        wartet = false;
        stickyMengeEinsetzen();
      });
    }).observe(ziel, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stickyMengeUeberwachen);
  } else {
    stickyMengeUeberwachen();
  }

  function stickyMenge() {
    var feld = stickyLeiste() && stickyLeiste().querySelector('.kindooly-sticky-menge__zahl');
    var wert = feld ? parseInt(feld.value, 10) : 1;
    return (wert > 0) ? wert : 1;
  }

  /* Die gewählte Variante steht als data-variant-id an der Option. Fehlt sie,
     wird nichts überschrieben und es gilt die Auswahl aus dem Hauptformular.
     Lieber die Farbe von oben als gar kein Kauf. */
  function stickyVariante() {
    var leiste = stickyLeiste();
    var wahl = leiste && leiste.querySelector('.sticky-atc__variant-select');
    if (!wahl) return null;
    var option = wahl.options[wahl.selectedIndex];
    return (option && option.getAttribute('data-variant-id')) || null;
  }

  /* Absenden des Produktformulars. In der Erfassungsphase, damit die
     Behandlung des Themes gar nicht erst drankommt.

     NUR das Formular, das auf /cart/add zeigt. Das Suchfeld, das Anmelde-
     formular und das Kontaktformular bleiben unberührt. Der Kaufknopf
     "Jetzt kaufen" von Shopify sitzt in einem eigenen Element und wird hier
     ebenfalls nicht abgefangen, er soll weiterhin direkt zur Kasse gehen. */
  document.addEventListener('submit', function (e) {
    var formular = e.target;
    if (!formular || formular.tagName !== 'FORM') return;

    var ziel = formular.getAttribute('action') || '';
    if (ziel.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    hinzufuegen(formular, formular.querySelector('[name="add"]'));
  }, true);

  document.addEventListener('click', function (e) {

    // Plus und Minus in der mitlaufenden Leiste
    var schritt = e.target.closest('.kindooly-sticky-menge__schritt');
    if (schritt) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var feld = schritt.parentNode.querySelector('.kindooly-sticky-menge__zahl');
      if (feld) {
        var neu = (parseInt(feld.value, 10) || 1) + parseInt(schritt.getAttribute('data-schritt'), 10);
        feld.value = (neu < 1) ? 1 : neu;   /* unten ist bei eins Schluss, gekauft wird mindestens eine */
      }
      return;
    }

    // Kaufknopf in der mitlaufenden Leiste
    var stickyKnopf = e.target.closest('.sticky-atc__add_button');
    if (stickyKnopf) {
      var formularId = stickyKnopf.getAttribute('form');
      var formular = formularId ? document.getElementById(formularId) : null;
      if (!formular) formular = document.querySelector('form[action*="/cart/add"]');
      if (!formular) return;          /* ohne Formular lieber nichts tun als etwas Falsches */

      e.preventDefault();
      e.stopImmediatePropagation();
      hinzufuegen(formular, stickyKnopf, { id: stickyVariante(), menge: stickyMenge() });
      return;
    }

    // Kreuz zum Entfernen
    var kreuz = e.target.closest('cart-remove-button');
    if (kreuz) {
      var zeileK = zeileVon(kreuz);
      if (zeileK === null) return;
      e.preventDefault();          // im Kreuz steckt ein Verweis als Rückfallweg
      e.stopImmediatePropagation();
      aendern(zeileK, 0, kreuz);
      return;
    }

    // Plus und Minus
    var knopf = e.target.closest('.quantity__button');
    if (!knopf || !knopf.closest(WARENKORB)) return;

    /* DAS MINUS DARF BEI MENGE 1 AUF NULL GEHEN, seit dem 2026-09-08.

       Anja: "man kann die Artikel im Warenkorb aktuell nur löschen, indem man
       auf die Mülltonne klickt. Wenn die Menge 1 ist, kann man sie nicht durch
       das - auf 0 setzen."

       Das kehrt ihre Entscheidung vom 2026-09-02 um. Damals galt: Die Menge
       hört bei 1 auf, zum Entfernen gibt es das Kreuz. Anlass war, dass das
       Theme bei Menge 1 die Klasse disabled an das Minus hängt und den Cursor
       "nicht erlaubt" zeigt, das Attribut disabled aber nicht setzt. Klicken
       ging trotzdem, und beides zusammen war widersprüchlich.

       Aufgelöst wird der Widerspruch jetzt andersherum: Das Minus zählt bis
       null durch und entfernt die Position, und die Optik zieht nach. Die
       Regel dafür steht unten im Stilblock dieser Datei.

       GESPERRT BLEIBT NUR, was das Theme wirklich sperrt, also ein echtes
       disabled-Attribut. Das steht zum Beispiel am Plus, wenn der Bestand
       erschöpft ist. */
    var istMinus = knopf.name === 'minus';

    if (knopf.disabled ||
        (!istMinus && knopf.classList.contains('disabled')) ||
        (!istMinus && knopf.getAttribute('aria-disabled') === 'true')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var umgebung = knopf.closest('quantity-input, .quantity');
    var feld = umgebung && umgebung.querySelector('input[name="updates[]"]');
    if (!feld) return;

    var zeileM = zeileVon(feld);
    if (zeileM === null) return;

    var jetzt = parseInt(feld.value, 10);
    if (isNaN(jetzt)) return;

    var neu = knopf.name === 'plus' ? jetzt + 1 : jetzt - 1;
    if (neu < 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    feld.value = neu;              // sofort sichtbar, der Server bestätigt gleich
    aendern(zeileM, neu, knopf);
  }, true);

  /* ---------------------------------------------------------------------
     DIE OPTION ZUM ANKREUZEN IM WARENKORB

     Anja am 2026-09-12: eine Zusatzleistung fuer 5,99 EUR, die immer im
     Warenkorb steht und per Haken dazukommt oder wieder verschwindet.

     Haken gesetzt   -> /cart/add.js mit der Variantennummer, Menge 1
     Haken entfernt  -> die Position im Warenkorb auf Menge 0 setzen

     DER HAKEN WIRD NIE GEMERKT, SONDERN GELESEN. Nach jeder Aenderung zeichnet
     die Section-Rendering-Schnittstelle den Warenkorb neu, und das Liquid setzt
     den Haken danach anhand des tatsaechlichen Inhalts. Damit kann die Anzeige
     nicht vom Warenkorb abweichen, auch nicht bei zwei offenen Fenstern.

     BEIM ABWAEHLEN WIRD DIE POSITION GESUCHT, NICHT GERATEN: Der Index einer
     Position aendert sich, sobald davor etwas entfernt wird. Deshalb wird er
     vor jedem Entfernen frisch aus /cart.js geholt.
     --------------------------------------------------------------------- */

  function schutzSperren(sperren) {
    var haken = document.querySelectorAll('.kindooly-schutz__haken');
    for (var i = 0; i < haken.length; i++) {
      haken[i].disabled = sperren;
      var kasten = haken[i].closest('.kindooly-schutz');
      if (kasten) kasten.classList.toggle('kindooly-schutz--laeuft', sperren);
    }
  }

  function schutzUmschalten(haken) {
    var nummer = haken.getAttribute('data-variante');
    if (!nummer) return;

    var formular = document.querySelector('form[action*="/cart/add"]');
    schutzSperren(true);

    if (haken.checked) {
      /* Ohne Produktformular auf dieser Seite reicht ein leeres Formular, die
         Werte kommen ohnehin aus zusatz. */
      hinzufuegen(formular || document.createElement('form'), null,
                  { id: nummer, menge: 1 });
      window.setTimeout(function () { schutzSperren(false); }, 1200);
      return;
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (a) { return a.json(); })
      .then(function (korb) {
        var zeile = 0;
        for (var i = 0; i < korb.items.length; i++) {
          if (String(korb.items[i].variant_id) === String(nummer)) { zeile = i + 1; break; }
        }
        if (zeile === 0) { schutzSperren(false); return; }
        aendern(zeile, 0, null);
        window.setTimeout(function () { schutzSperren(false); }, 1200);
      })
      .catch(function () {
        schutzSperren(false);
        fehlerZeigen('Die Option konnte gerade nicht geändert werden. Bitte noch einmal versuchen.');
      });
  }

  document.addEventListener('change', function (e) {
    var haken = e.target.closest('.kindooly-schutz__haken');
    if (haken) {
      e.stopImmediatePropagation();
      schutzUmschalten(haken);
      return;
    }

    var feld = e.target.closest('input[name="updates[]"]');
    if (!feld) return;

    var zeile = zeileVon(feld);
    var menge = parseInt(feld.value, 10);
    if (zeile === null || isNaN(menge) || menge < 0) return;

    e.stopImmediatePropagation();
    aendern(zeile, menge, feld);
  }, true);

  /* ---------------------------------------------------------------------
     RABATTCODE IM WARENKORB EINLÖSEN

     Anja am 2026-09-16: "Wenn man einen Rabattcode eingibt, und bestätigt,
     dann kommt man zum Checkout. Ich möchte aber, dass der im Warenkorb
     einfach gültig ist und man trotzdem auf der Seite bleibt."

     WARUM SHRINE ZUM CHECKOUT SPRINGT: Shopify kennt keinen Aufruf, der einen
     Code direkt auf den Warenkorb legt. Der einzige Weg führt über
     /discount/<code>, und diese Adresse leitet danach weiter. Ohne Angabe
     landet man an der Kasse. Shrines handleDiscountForm macht genau das.

     WAS STATTDESSEN PASSIERT: Derselbe Aufruf, aber mit ?redirect= auf die
     Seite, auf der man gerade steht. Der Code liegt danach in der Sitzung und
     wirkt auf den Warenkorb. Am 2026-09-16 am Shop gemessen: 64,97 EUR wurden
     zu 61,73 EUR, und cart_level_discount_applications trug WILLKOMMEN5.

     Die Weiterleitung selbst sieht niemand, weil fetch sie schluckt. Danach
     werden die Abschnitte neu gezeichnet, genau wie nach einer
     Mengenänderung. Es gibt keinen Seitenwechsel.

     WIE EIN FALSCHER CODE ERKANNT WIRD: /discount/ meldet nichts. Ein
     unbekannter Code leitet genauso weiter wie ein gültiger, er liegt danach
     nur nicht im Warenkorb. Deshalb wird hinterher nachgesehen, ob er
     wirklich angekommen ist.
     --------------------------------------------------------------------- */
  function rabattFehler(formular, text) {
    var stelle = formular.querySelector('.cart-discount-form__error');
    if (!stelle) return;
    if (text) {
      stelle.textContent = text;
      stelle.style.display = 'block';
      stelle.setAttribute('role', 'alert');
    } else {
      stelle.style.display = 'none';
      stelle.removeAttribute('role');
    }
  }

  function rabattEinloesen(formular, ausloeser) {
    if (laeuft) return;

    var feld = formular.querySelector('input[name="cart-discount-field"]');
    var code = feld ? (feld.value || '').trim() : '';
    if (!code) {
      rabattFehler(formular, 'Bitte gib einen Rabattcode ein.');
      if (feld) feld.focus();
      return;
    }

    laeuft = true;
    var teile = huellen();
    rabattFehler(formular, '');
    fehlerLoeschen();
    ladenAn(ausloeser);

    var hierher = window.location.pathname + window.location.search;

    fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(hierher), {
      method: 'GET',
      redirect: 'follow'
    })
      .then(function () {
        /* Leeres updates ändert nichts am Inhalt, liefert aber Warenkorbdaten
           und frische Abschnitte in einem Zug. */
        return fetch(window.routes.cart_update_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            updates: {},
            sections: teile.map(function (t) { return t.id; }).join(','),
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (antwort) { return antwort.json(); })
      .then(function (warenkorb) {
        /* GEPRUEFT WIRD AN discount_codes, nicht an den Rabattanwendungen.
           Zwei Gruende: Das Feld nennt den Code so, wie er eingetippt wurde,
           und es sagt mit applicable, ob er auf diesen Warenkorb passt. Damit
           laesst sich ein unbekannter Code von einem unterscheiden, der zwar
           existiert, aber etwa einen Mindestbestellwert verlangt.

           Der Umweg ueber cart_level_discount_applications waere ausserdem
           eine Falle: /cart.js liefert Titel und Typ flach, /cart/update.js
           verschachtelt sie unter discount_application. Am 2026-09-16 genau
           darueber gestolpert, die Pruefung schlug fehl, obwohl der Rabatt
           laengst wirkte. */
        var codes = warenkorb.discount_codes || [];
        var eintrag = null;
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code).toLowerCase() === code.toLowerCase()) eintrag = codes[i];
        }

        if (!eintrag) {
          rabattFehler(formular, 'Diesen Code kennen wir nicht. Prüf bitte die Schreibweise.');
          if (feld) feld.select();
          return;
        }
        if (!eintrag.applicable) {
          rabattFehler(formular, 'Dieser Code gilt für deinen Warenkorb nicht.');
          if (feld) feld.select();
          return;
        }

        zeichnen(teile, warenkorb.sections);
        if (feld) feld.value = '';
        ansagen('Rabattcode ' + code + ' eingelöst.');
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true, detail: { cart: warenkorb }
        }));
      })
      .catch(function () {
        rabattFehler(formular, 'Das hat gerade nicht geklappt. Bitte noch einmal versuchen.');
      })
      .then(function () {
        laeuft = false;
        ladenAus();
      });
  }

  /* Vor Shrines eigenem onsubmit abfangen. Der steht als Attribut am Formular
     und läuft am Ziel, dieser Zugriff hier läuft davor und hält das Ereignis
     an. So bleibt das Snippet unberührt. */
  document.addEventListener('submit', function (e) {
    var formular = e.target.closest('.cart-discount-form');
    if (!formular) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    rabattEinloesen(formular, formular.querySelector('button[type="submit"]'));
  }, true);

  /* Enter im Zahlenfeld löst kein change aus, wenn der Wert gleich bleibt,
     schickt aber das Formular ab und lädt die Seite neu. Das ist hier
     unerwünscht, die Änderung läuft über change. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var feld = e.target.closest('input[name="updates[]"]');
    if (!feld) return;
    e.preventDefault();
    feld.blur();                   // löst change aus, falls der Wert neu ist
  }, true);

})();
